import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tnzgvgustz: FaireBrandEntity = {
  token: "b_tnzgvgustz",
  type: "brand",
  name: "Pacific North Wicks",
  avatarUrl:
    "https://cdn.faire.com/fastly/51795cfdc43763249c9cd335827d0972ca6fa8c8a9e56175a5dd35807ba089b8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3d082118e8fc261130b3c654efc2e043184fc689cb97a12da85699e2b856dc4b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/51795cfdc43763249c9cd335827d0972ca6fa8c8a9e56175a5dd35807ba089b8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3d082118e8fc261130b3c654efc2e043184fc689cb97a12da85699e2b856dc4b.png",
  location: "98332, WA, USA",
  minimumOrderDollars: 144,
  rating: 5,
  reviewCount: 10,
  isTopShop: true,
  isInsider: true,
  description:
    "Pacific North Wicks is a woman-owned artisanal candle company located in beautiful Gig Harbor, WA. Each of our handcrafted candles is inspired by the enchanting beauty and mystical spirit of the Pacific Northwest.  We are obsessed with the exquisite, nature-forward fragrances we have thoughtfully curated for our collections. We are passionate about creating high quality, beautifully fragranced candles that are better for you and better for our amazing planet. We are conscious of our ingredients and packaging to provide you with an eco-friendly product you can feel good about purchasing.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:56.154Z",
    importedBy: "entity-db-cli",
  },
};
